<template>
  <div class="card-list">
    <ShadowBoxTitleDescription
      class="shadow-box"
      :title="cardListTitle"
      opacity="_60">
      <div class="card-list-container">
        <slot></slot>
        <div class="scroll-container">
          <template v-for="(cardItem, index) in cardList">
            <div class="card-container" :key="index">
              <img
                class="card"
                :src="cardItem.image" :alt="cardItem.card_name"
              >
              <div class="card-info">
                <div class="name">
                  <span class="text">{{cardItem.name}}</span>
                </div>
                <div class="model-number">
                  <span class="text">{{cardItem.model_number}}</span>
                </div>
                <div class="rarity">
                  <span class="text">{{cardItem.rarity}}</span>
                </div>
                <!-- <div class="model-number">
                  <span class="text">在庫数:{{ cardItem.stock }}枚</span>
                </div> -->
                <div class="point_area">
                  <span class="point">{{cardItem.sub_coin | comma}}</span>
                </div>
                <!-- <div class="model-number">
                  <SelectBox
                    class="select-box prefecture-id"
                    :options="getTotalChangeNumList(cardItem)"
                    selectedOption="0"
                    placeholder=""
                    @handleSelectChange="selectNum(cardItem, $event)"
                  />
                </div> -->
              </div>
              <BlackGradationButton
                class="square-button"
                :text="t('引換')"
                @handleSquareBtnClick="handleSquareBtnClick(cardItem)"
              />
            </div>
          </template>
        </div>
      </div>
    </ShadowBoxTitleDescription>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import t from '@/plugins/i18n';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
// import SelectBox from '@/components/atoms/SelectBox.vue';

export default {
  name: 'CardList',
  mixins: [t],

  data: () => ({
    changeNum: {},
  }),

  props: {
    cardListTitle: {
      type: String,
    },
    cardList: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    ShadowBoxTitleDescription,
    BlackGradationButton,
    // SelectBox,
    // PrevButton,
    // NextButton,
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  methods: {
    // handlePrevBtnClick() {
    //   this.$emit('handlePrevBtnClick');
    // },
    // handleNextBtnClick() {
    //   this.$emit('handleNextBtnClick');
    // },
    handleSquareBtnClick(card) {
      // const changeNum = this.changeNum[card.id];
      const changeNum = 1;
      if (changeNum === undefined || changeNum === 0) {
        window.alert('引換数を選択してください。');
      } else {
        const sendCard = card;
        sendCard.change_num = changeNum;
        this.$emit('handleSquareBtnClick', card);
      }
    },
    selectNum(card, num) {
      this.changeNum[card.id] = num;
    },
    getTotalChangeNumList(card) {
      const rtnData = [];
      rtnData.push({ id: 0, name: '引換数' });

      let maxSize = 5;
      if (maxSize > card.stock) {
        maxSize = card.stock;
      }
      for (let i = 1; i <= maxSize; i += 1) {
        rtnData.push({ id: i, name: i });
      }

      return rtnData;
    },
  },
};
</script>

<style lang="scss" scoped>
$shadowBtnHeight: 77px;

.card-list{
  width: 100%;
  .card-list-container{
    position: relative;
    width: 100%;
    min-height: 154px;
    // margin-top: 10px;
    white-space: nowrap;
    .btn{
      position: absolute;
      height: $shadowBtnHeight;
      top: calc(50% - #{$shadowBtnHeight}/2);
      &.prev{
        left: 10px;
      }
      &.next{
        right: 10px;
      }
      @media screen and  (min-width: $tabletWidth) {
        display: none;
      }
    }
    .scroll-container{
      margin: 10px auto 50px auto;
      max-width: 1220px;
      display: flex;
      // overflow: hidden;
      // overflow-x: auto;
      flex-wrap: wrap;
      justify-content: center;
      @media screen and  (min-width: $tabletWidth) {
        display: flex;
        justify-content: center;
        // flex-wrap: wrap;
        overflow: visible;
        margin-top: 10px;
      }
      // &::before{
      //   content: '';
      //   min-width: 20px;
      //   flex: 1;
      //   height: 10px;
      // }
      // &::after{
      //   content: '';
      //   min-width: 20px;
      //   flex: 1;
      //   height: 10px;
      // }
      .card-container{
        display: flex;
        flex-direction: column;
        width: 100px;
        min-width: 100px;
        margin: 0 10px 10px 10px;
        // &:first-of-type{
        //   margin: 0 auto;
        // }
        .card-info{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          width: 100%;
          .name, .model-number{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding: 2px 2px;
            .text{
              display: inline-block;
              font-family: $notoSans;
              font-size: 12px;
              color: $black;
              line-height: 1.25;
              white-space: pre-wrap;
            }
          }
          .num {
            .text {
              color: $black;
            }
          }
          .rarity {
            padding: 0px 10px 4px 10px;
            border-radius: 5px;
            border: solid 1px $mainColor;
            background-color: $mainColor;
            span {
              white-space: pre-wrap;
              display: inline;
              font-size: 12px;
              color: $white;
            }
          }
          .point_area {
            font-size: 12px;
            color: $black;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .point {
              font-size: 20px;
              font-weight: 700;
              margin-left: 5px;
              position: relative;
              display: flex;
              align-items: center;
              &:before {
                content: "C";
                font-size: 15px;
                width: 24px;
                height: 24px;
                border-radius: 100px;
                display:inline-flex;
                justify-content: center;
                align-items: center;
                background-color: #fff6bd;
                border: solid 1px #d99e2c;
                color: #d79a25;
                margin-right: 5px;
                position: relative;
                top: 0px;
              }
            }
          }
        }
        .square-button {
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
